// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-74e128ad{50%{opacity:.5}}.title-navbar-report[data-v-74e128ad]{color:#7a7a7a;font-weight:400;font-size:14px}.subtitle-navbar-report[data-v-74e128ad]{color:#7a7a7a;font-weight:400;font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
